module.exports = __webpack_public_path__ + "img/result_txt_d.b4a18323.png";